import React, {useEffect, useRef, useState} from "react";
import {AlsoBought} from "../../AlsoBought/AlsoBought";
import {useI18N} from "../../../../my-puratos/hoc/withI18N";

const getScrollBottom = (element) => {
    return element.scrollHeight - element.scrollTop - element.clientHeight;
}

export const OverlayCrossSell = () => {
    const [isScrolled, setIsScrolled] = useState('top');
    const crossSellRef = useRef(null);
    const translate = useI18N();

    useEffect(() => {
        const element = crossSellRef.current;

        if (!element || element.clientHeight >= element.scrollHeight) return;

        const handleScroll = () => {
            const elementIsTop = element.scrollTop === 0;
            const elementIsBottom = getScrollBottom(crossSellRef.current) <= 5;

            setIsScrolled(elementIsTop ? 'top' : elementIsBottom ? 'bottom' : 'middle');
        };

        element.addEventListener('scroll', handleScroll);

        handleScroll();

        return () => {
            element.removeEventListener('scroll', handleScroll);
        };
    }, [crossSellRef.current]);

    return (
        <>
            <h2>{translate('Other customers bought')}</h2>
            <div
                ref={crossSellRef}
                className={`overlay-content__crosssell overlay-content__crosssell--scrolled-${isScrolled}`}>
                <AlsoBought isCarousel={false}/>
            </div>
        </>
    )
}
